<template>
    <div>
        <router-link :class="isActive(parent.slug) || isActiveParent(parent.slug) ? 'active' : ''"
                     style="width: 80%;display: inline-block; white-space: nowrap;"
                     :to="{name: `app.${type}.category`,
                               params: { category:  parent.slug}}">{{parent.name}}</router-link>
        <div style="width: 20%;display: inline-block;">
            <a href="javascript:void(0)" @click="toggle(containerId)" style="width:100%; text-align: center"><span class="fa fa-caret-down"></span></a>
        </div>
        <div :class="['panel-collapse', 'collapse', isActiveParent(parent.slug) || isActive(parent.slug) ? 'show': '' ]"
             :ref="containerId">
            <div class="panel-body">
                <ul class="nav navbar-nav">
                    <li v-for="item in subItem" :key="item.name">
                        <div v-if="item.children.length > 0">
                            <SidebarNavigationSubItem
                                    :sub-item="item.children"
                                    :parent=item
                                    :prev-slugs="prevSlugs + '/' + item.slug"
                            />
                        </div>
                        <div v-else>
                            <router-link :class="isActive(prevSlugs + '/'+ item.slug) ? 'active' : ''"
                                         :to="{name: `app.${type}.category`,
                               params: { category:  prevSlugs + '/'+ item.slug}}">{{item.name}}</router-link>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SidebarNavigationSubItem",
        props: ['subItem', 'parent', 'prevSlugs', 'type', 'typeAlt'],
        created() {
            this.containerId = parent.slug + '_' + Date.now();
        },
        data() {
            return {
                containerId: null,
                slugs: this.prevSlugs
            }
        },
        methods: {
            toggle(target) {
                if (this.$refs[target].classList.contains('collapse')) {
                    this.$refs[target].classList.remove('collapse');
                } else {
                    this.$refs[target].classList.add('collapse');
                }
            },

            isActiveParent(slug) {
                if (this.$route.params.category) {
                    let end = this.$route.params.category.split('/').pop();
                    return `/${this.typeAlt}/${this.$route.params.category}`.indexOf(`/${this.typeAlt}/${slug}/${end}`) > -1;
                }

                if (this.$route.params.product) {
                    let path = this.$route.params.product.split('/');
                    path.pop();
                    let end = path.pop();
                    return `/${this.type}/${this.$route.params.product}`.indexOf(`/${this.type}/${slug}/${end}`) > -1;
                }
            },

            isActive(slug) {
                let path = this.$route.fullPath.split('/');
                if (path.indexOf('app') > -1) {
                    path.splice(path.indexOf('app'), 1);
                }
                return path.join('/') === (`/${this.typeAlt}/${slug}`);
            },
        }
    }
</script>

<style scoped>

</style>
